import type { Jurisdiction } from "../api/types";

/**
 * What a coverage row says where the county named no town.
 *
 * Okaloosa, 1 Oct 2026: 83 condominium units the county records with no
 * address at all — no street, no town, no ZIP, no building — printed as a
 * blank row with a number beside it. The parcels are real; the town is not
 * something the record says, so the row says that rather than guessing one.
 */
export const UNNAMED_JURISDICTION = "No town on the county's record";

export function jurisdictionLabel(name: string | null | undefined): string {
  return (name ?? "").trim() || UNNAMED_JURISDICTION;
}

export function isNamed(row: Jurisdiction): boolean {
  return Boolean((row.municipality ?? "").trim());
}

/** The named rows in the order given, then the one the county left blank. */
export function namedFirst(rows: Jurisdiction[]): Jurisdiction[] {
  return [...rows.filter(isNamed), ...rows.filter((row) => !isNamed(row))];
}
